import { render, staticRenderFns } from "./houses.vue?vue&type=template&id=0cc00336&scoped=true"
import script from "./houses.vue?vue&type=script&lang=js"
export * from "./houses.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "0cc00336",
  null
  
)

export default component.exports